/**
 * The attack macros' store (v8.327.0).
 *
 * Macros were `useState({})` and died on every reload - the one thing a
 * "save this configuration" feature must not do. They are the viewer's
 * own attack habits, keyed by the profile they were saved under, so they
 * live in this browser's localStorage beside the viewer prefs: never
 * synced, never in the character, never in the session document. A
 * corrupt or absent store reads as empty.
 */
const STORAGE_KEY = 'dw-attack-macros';

export type MacroMap = Record<string, unknown[]>;

export function loadMacros(): MacroMap {
  try {
    const parsed = JSON.parse(globalThis.localStorage?.getItem(STORAGE_KEY) || '');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? (parsed as MacroMap) : {};
  } catch {
    return {};
  }
}

export function saveMacros(macros: MacroMap): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, JSON.stringify(macros));
  } catch {
    // Private mode or a full store: the macros live on in memory for the session.
  }
}
